<p>cstp-registry works!</p>
